import { Modal } from 'react-bootstrap';
import { I18n } from '@/i18n/I18n';

export function LoadingModal(props: { message: string }) {
  const { message } = props;
  return (
    <Modal show centered>
      <Modal.Header>
        <Modal.Title>{message}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column align-items-center">
        <span className="spinner-border spinner-border-lg" aria-hidden="true" aria-label={I18n.get('loading')} />
      </Modal.Body>
    </Modal>
  );
}
